import cn from 'classnames';

import { hasNonWhiteTheme } from 'src/utils/hasNonWhiteTheme';

import { ComponentProps } from 'src/types/component-props';
import { CoreCrossLinksData } from 'src/types/components';

import CrossLink from 'components/BaseHelpers/CrossLink';
import RichText from 'components/BaseHelpers/RichText';
import Text from 'components/BaseHelpers/Text';

import styles from './CoreCrossLinks.module.scss';

export type CoreCrossLinksProps = ComponentProps & CoreCrossLinksData;

const CoreCrossLinks = ({ fields }: CoreCrossLinksProps): JSX.Element => {
  const { header, theme, list, anchorTag } = fields;

  const hasDarkerBackground = hasNonWhiteTheme(theme) && 'spacer--with-vertical-padding';

  const hasHeader = Object.values(header).some(Boolean);
  const themeClass = `theme--${theme}`;

  const customGridClass = list.length <= 2 && styles['grid--centered'];

  return (
    <section
      id={anchorTag}
      className={cn(styles.corecrosslinks, styles[themeClass], 'spacer', hasDarkerBackground)}
    >
      <div className={cn('container', 'container--true-1440')}>
        {hasHeader && (
          <div className={cn(styles.header)}>
            {header.eyebrow && <div className={cn(styles.eyebrow)}>{header?.eyebrow}</div>}
            {header.heading && (
              <h2 className={cn(styles.heading)}>
                <Text field={header.heading} />
              </h2>
            )}
            {header.description && (
              <RichText className={styles.description} field={header.description} />
            )}
          </div>
        )}

        <ul className={cn(styles.grid, customGridClass)} aria-label="Cross Links Navigation">
          {list.map((item, index) => {
            return (
              <li className={styles.gridItem} key={`CrossLinks-${index}`}>
                <CrossLink {...item} />
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default CoreCrossLinks;
